import Image from "next/image";
import { useState } from "react";

type IconStateButtonProps = {
  baseIcon: string;
  hoverIcon: string;
  activeIcon: string;
  onClick?: () => void;
  isActive?: boolean;
  size?: number;
};

const IconStateButton = ({
  baseIcon,
  hoverIcon,
  activeIcon,
  onClick,
  isActive,
  size,
}: IconStateButtonProps) => {
  const [isHover, setIsHover] = useState(false);

  const onMouseEnter = () => setIsHover(true);
  const onMouseLeave = () => {
    setIsHover(false);
  };
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const icon = isActive ? activeIcon : isHover ? hoverIcon : baseIcon;

  return (
    <Image
      width={size ? size : 20}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={(e) => {
        e.stopPropagation();
        handleClick();
      }}
      src={icon}
      alt="icon"
      style={{ cursor: "pointer" }}
    />
  );
};

export default IconStateButton;
